export default {
    mlb: {
        awayTeam: {
            players: [
                {
                    id: 1234980108,
                    name: 'Brayan Bello',
                    position: 'SP',
                    teamId: 33,
                },
                {
                    id: 4244682297,
                    name: 'Brennan Bernardino',
                    position: 'RP',
                    teamId: 33,
                },
                {
                    id: 3920946292,
                    name: 'Walker Buehler',
                    position: 'SP',
                    teamId: 33,
                },
                {
                    id: 843659303,
                    name: 'Aroldis Chapman',
                    position: 'RP',
                    teamId: 33,
                },
                {
                    id: 477510030,
                    name: 'Garrett Crochet',
                    position: 'SP',
                    teamId: 33,
                },
                {
                    id: 868441628,
                    name: 'Lucas Giolito',
                    position: 'SP',
                    teamId: 33,
                },
                {
                    id: 3682023071,
                    name: 'Jordan Hicks',
                    position: 'RP',
                    teamId: 33,
                },
                {
                    id: 2033201614,
                    name: 'Steven Matz',
                    position: 'RP',
                    teamId: 33,
                },
                {
                    id: 311146673,
                    name: 'Dustin May',
                    position: 'SP',
                    teamId: 33,
                },
                {
                    id: 2792424197,
                    name: 'Jovani Moran',
                    position: 'RP',
                    teamId: 33,
                },
                {
                    id: 1452657262,
                    name: 'Greg Weissert',
                    position: 'RP',
                    teamId: 33,
                },
                {
                    id: 3649032497,
                    name: 'Garrett Whitlock',
                    position: 'RP',
                    teamId: 33,
                },
                {
                    id: 1339419270,
                    name: 'Justin Wilson',
                    position: 'RP',
                    teamId: 33,
                },
                {
                    id: 3902747730,
                    name: 'Carlos Narvaez',
                    position: 'C',
                    teamId: 33,
                },
                {
                    id: 1431491083,
                    name: 'Connor Wong',
                    position: 'C',
                    teamId: 33,
                },
                {
                    id: 903535207,
                    name: 'Alex Bregman',
                    position: '3B',
                    teamId: 33,
                },
                {
                    id: 2602116594,
                    name: 'Nate Eaton',
                    position: '3B',
                    teamId: 33,
                },
                {
                    id: 445367554,
                    name: 'Romy Gonzalez',
                    position: '1B',
                    teamId: 33,
                },
                {
                    id: 297458405,
                    name: 'David Hamilton',
                    position: '2B',
                    teamId: 33,
                },
                {
                    id: 1507122808,
                    name: 'Nathaniel Lowe',
                    position: '1B',
                    teamId: 33,
                },
                {
                    id: 949063878,
                    name: 'Trevor Story',
                    position: 'SS',
                    teamId: 33,
                },
                {
                    id: 2006139703,
                    name: 'Roman Anthony',
                    position: 'RF',
                    teamId: 33,
                },
                {
                    id: 888117791,
                    name: 'Jarren Duran',
                    position: 'LF',
                    teamId: 33,
                },
                {
                    id: 2450429114,
                    name: 'Jhostynxon Garcia',
                    position: 'CF',
                    teamId: 33,
                },
                {
                    id: 155163255,
                    name: 'Ceddanne Rafaela',
                    position: 'CF',
                    teamId: 33,
                },
                {
                    id: 3866230573,
                    name: 'Masataka Yoshida',
                    position: 'LF',
                    teamId: 33,
                },
            ],
            teamId: 33,
            teamName: 'Boston Red Sox',
        },
        homeTeam: {
            players: [
                {
                    id: 1179030341,
                    name: 'Keegan Akin',
                    position: 'RP',
                    teamId: 7654,
                },
                {
                    id: 4154454841,
                    name: 'Kyle Bradish',
                    position: 'SP',
                    teamId: 7654,
                },
                {
                    id: 2851646742,
                    name: 'Yennier Cano',
                    position: 'RP',
                    teamId: 7654,
                },
                {
                    id: 2691434157,
                    name: 'Dietrich Enns',
                    position: 'RP',
                    teamId: 7654,
                },
                {
                    id: 212516523,
                    name: 'Rico Garcia',
                    position: 'RP',
                    teamId: 7654,
                },
                {
                    id: 3891526603,
                    name: 'Yaramil Hiraldo',
                    position: 'RP',
                    teamId: 7654,
                },
                {
                    id: 4197661437,
                    name: 'Dean Kremer',
                    position: 'SP',
                    teamId: 7654,
                },
                {
                    id: 1810590193,
                    name: 'Corbin Martin',
                    position: 'RP',
                    teamId: 7654,
                },
                {
                    id: 3187064755,
                    name: 'Cade Povich',
                    position: 'SP',
                    teamId: 7654,
                },
                {
                    id: 3045948481,
                    name: 'Trevor Rogers',
                    position: 'SP',
                    teamId: 7654,
                },
                {
                    id: 2281802839,
                    name: 'Kade Strowd',
                    position: 'RP',
                    teamId: 7654,
                },
                {
                    id: 3052149189,
                    name: 'Tomoyuki Sugano',
                    position: 'SP',
                    teamId: 7654,
                },
                {
                    id: 2396499683,
                    name: 'Grant Wolfram',
                    position: 'RP',
                    teamId: 7654,
                },
                {
                    id: 134481740,
                    name: 'Samuel Basallo',
                    position: 'C',
                    teamId: 7654,
                },
                {
                    id: 1095381178,
                    name: 'Alex Jackson',
                    position: 'C',
                    teamId: 7654,
                },
                {
                    id: 374565594,
                    name: 'Gunnar Henderson',
                    position: 'SS',
                    teamId: 7654,
                },
                {
                    id: 3944632260,
                    name: 'Jackson Holliday',
                    position: '2B',
                    teamId: 7654,
                },
                {
                    id: 2631775559,
                    name: 'Jeremiah Jackson',
                    position: '2B',
                    teamId: 7654,
                },
                {
                    id: 1778479003,
                    name: 'Vimael Machin',
                    position: 'SS',
                    teamId: 7654,
                },
                {
                    id: 3709984740,
                    name: 'Coby Mayo',
                    position: '1B',
                    teamId: 7654,
                },
                {
                    id: 2526453158,
                    name: 'Ryan Mountcastle',
                    position: '1B',
                    teamId: 7654,
                },
                {
                    id: 1083569520,
                    name: 'Luis Vazquez',
                    position: 'SS',
                    teamId: 7654,
                },
                {
                    id: 3848914745,
                    name: 'Dylan Beavers',
                    position: 'RF',
                    teamId: 7654,
                },
                {
                    id: 248665581,
                    name: 'Dylan Carlson',
                    position: 'LF',
                    teamId: 7654,
                },
                {
                    id: 4209316041,
                    name: 'Colton Cowser',
                    position: 'LF',
                    teamId: 7654,
                },
                {
                    id: 2539819013,
                    name: 'Daniel Johnson',
                    position: 'CF',
                    teamId: 7654,
                },
            ],
            teamId: 7654,
            teamName: 'Baltimore Orioles',
        },
    },
    nfl: {
        awayTeam: {
            players: [],
        },
        homeTeam: {
            players: [],
        },
    },
    nba: {
        awayTeam: {
            players: [
                {
                    id: 471745621,
                    infoLink: 'https://www.espn.com/nba/player/_/id/3135045/grayson-allen',
                    name: 'Grayson Allen',
                    position: 'G',
                    teamId: 234345,
                },
                {
                    id: 591407538,
                    infoLink: 'https://www.espn.com/nba/player/_/id/3136193/devin-booker',
                    name: 'Devin Booker',
                    position: 'G',
                    teamId: 234345,
                },
                {
                    id: 1231334408,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4280245/jamaree-bouyea',
                    name: 'Jamaree Bouyea',
                    position: 'G',
                    teamId: 234345,
                },
                {
                    id: 2942904093,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4591259/koby-brea',
                    name: 'Koby Brea',
                    position: 'G',
                    teamId: 234345,
                },
                {
                    id: 4014473498,
                    infoLink: 'https://www.espn.com/nba/player/_/id/3155526/dillon-brooks',
                    name: 'Dillon Brooks',
                    position: 'F',
                    teamId: 234345,
                },
                {
                    id: 3203806417,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4888725/ryan-dunn',
                    name: 'Ryan Dunn',
                    position: 'F',
                    teamId: 234345,
                },
                {
                    id: 3142544268,
                    infoLink: 'https://www.espn.com/nba/player/_/id/5105977/rasheer-fleming',
                    name: 'Rasheer Fleming',
                    position: 'F',
                    teamId: 234345,
                },
                {
                    id: 3067735969,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4278585/collin-gillespie',
                    name: 'Collin Gillespie',
                    position: 'G',
                    teamId: 234345,
                },
                {
                    id: 770040203,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4278402/jordan-goodwin',
                    name: 'Jordan Goodwin',
                    position: 'G',
                    teamId: 234345,
                },
                {
                    id: 4249509997,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4437244/jalen-green',
                    name: 'Jalen Green',
                    position: 'G',
                    teamId: 234345,
                },
                {
                    id: 1113280311,
                    infoLink: 'https://www.espn.com/nba/player/_/id/3059409/nigel-hayes-davis',
                    name: 'Nigel Hayes-Davis',
                    position: 'F',
                    teamId: 234345,
                },
                {
                    id: 197092826,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4601023/oso-ighodaro',
                    name: 'Oso Ighodaro',
                    position: 'F',
                    teamId: 234345,
                },
                {
                    id: 1238958906,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4277957/isaiah-livers',
                    name: 'Isaiah Livers',
                    position: 'F',
                    teamId: 234345,
                },
                {
                    id: 1255431471,
                    infoLink: 'https://www.espn.com/nba/player/_/id/5203685/khaman-maluach',
                    name: 'Khaman Maluach',
                    position: 'C',
                    teamId: 234345,
                },
                {
                    id: 3061553733,
                    infoLink: 'https://www.espn.com/nba/player/_/id/2583632/royce-oneale',
                    name: "Royce O'Neale",
                    position: 'F',
                    teamId: 234345,
                },
                {
                    id: 1099322325,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4278076/nick-richards',
                    name: 'Nick Richards',
                    position: 'C',
                    teamId: 234345,
                },
                {
                    id: 1484098699,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4701232/mark-williams',
                    name: 'Mark Williams',
                    position: 'C',
                    teamId: 234345,
                },
            ],
        },
        homeTeam: {
            players: [
                {
                    id: 730317706,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4278129/deandre-ayton',
                    name: 'Deandre Ayton',
                    position: 'C',
                    teamId: 8922,
                },
                {
                    id: 1291519059,
                    infoLink: 'https://www.espn.com/nba/player/_/id/3945274/luka-doncic',
                    name: 'Luka Doncic',
                    position: 'G',
                    teamId: 8922,
                },
                {
                    id: 3271718758,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4066648/rui-hachimura',
                    name: 'Rui Hachimura',
                    position: 'F',
                    teamId: 8922,
                },
                {
                    id: 4104844239,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4397077/jaxson-hayes',
                    name: 'Jaxson Hayes',
                    position: 'C',
                    teamId: 8922,
                },
                {
                    id: 1210314640,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4683774/bronny-james',
                    name: 'Bronny James',
                    position: 'G',
                    teamId: 8922,
                },
                {
                    id: 2341602274,
                    infoLink: 'https://www.espn.com/nba/player/_/id/1966/lebron-james',
                    name: 'LeBron James',
                    position: 'F',
                    teamId: 8922,
                },
                {
                    id: 4074718856,
                    infoLink: 'https://www.espn.com/nba/player/_/id/2960236/maxi-kleber',
                    name: 'Maxi Kleber',
                    position: 'F',
                    teamId: 8922,
                },
                {
                    id: 3225631237,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4897943/dalton-knecht',
                    name: 'Dalton Knecht',
                    position: 'F',
                    teamId: 8922,
                },
                {
                    id: 918631603,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4592691/jake-laravia',
                    name: 'Jake LaRavia',
                    position: 'F',
                    teamId: 8922,
                },
                {
                    id: 3095578302,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4702972/chris-manon',
                    name: 'Chris Manon',
                    position: 'G',
                    teamId: 8922,
                },
                {
                    id: 3750115954,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4066457/austin-reaves',
                    name: 'Austin Reaves',
                    position: 'G',
                    teamId: 8922,
                },
                {
                    id: 3520630434,
                    infoLink: 'https://www.espn.com/nba/player/_/id/2990992/marcus-smart',
                    name: 'Marcus Smart',
                    position: 'G',
                    teamId: 8922,
                },
                {
                    id: 21296226,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4683686/nick-smith-jr',
                    name: 'Nick Smith Jr.',
                    position: 'G',
                    teamId: 8922,
                },
                {
                    id: 1226806698,
                    infoLink: 'https://www.espn.com/nba/player/_/id/5060631/adou-thiero',
                    name: 'Adou Thiero',
                    position: 'F',
                    teamId: 8922,
                },
                {
                    id: 4083949095,
                    infoLink: 'https://www.espn.com/nba/player/_/id/4278077/jarred-vanderbilt',
                    name: 'Jarred Vanderbilt',
                    position: 'F',
                    teamId: 8922,
                },
                {
                    id: 2860336366,
                    infoLink: 'https://www.espn.com/nba/player/_/id/3137259/gabe-vincent',
                    name: 'Gabe Vincent',
                    position: 'G',
                    teamId: 8922,
                },
            ],
        },
    },
    cbb: {
        awayTeam: {
            players: [],
        },
        homeTeam: {
            players: [],
        },
    },
    cfb: {
        awayTeam: {
            players: [],
        },
        homeTeam: {
            players: [],
        },
    },
    nhl: {
        awayTeam: {
            players: [],
        },
        homeTeam: {
            players: [],
        },
    },
};
